import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Risk = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Risk' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M14,10 L15,10 L15,9 L14,9 L14,10 Z M18,10 L19,10 L19,9 L18,9 L18,10 Z M18,6 L19,6 L19,5 L18,5 L18,6 Z M14,6 L15,6 L15,5 L14,5 L14,6 Z M9,19 L10,19 L10,18 L9,18 L9,19 Z M5,15 L6,15 L6,14 L5,14 L5,15 Z M10,10 L1,10 L1,23 L14,23 L14,14 M10,14 L23,14 L23,1 L10,1 L10,14 Z' />
  </StyledIcon>
);
